import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId, useCurrentJobId } from "@/hooks";
import { httpClient } from "@/lib/http";
import { CandidacyWithProfileResponse, HttpResponse } from "@/types";

export function useGetCandidacies() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: ["candidacies", currentCompanyId, currentJobId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies`;
      const res = await httpClient.get<
        CandidacyWithProfileResponse[],
        HttpResponse<CandidacyWithProfileResponse[]>
      >(path);
      return res.data;
    },
  });
}
